import { clsx } from 'clsx';
import { InventoryData } from '../types';

type PArticle = {
  inventory: Pick<InventoryData, 'quantityStocked' | 'deliveryTimeEst' | 'leadTimeEst'>[]
}

interface DeliveryEstimateProps {
  article: PArticle;
  t: (key: string, options?: any) => string;
}

type IndicatorCollor = 'bg-primary-green' | 'bg-primary-yellow';

const DeliveryEstimate = (props: DeliveryEstimateProps) => {
  const { article, t } = props;
  const inventory =
    article.inventory && (article.inventory[0]);

  //
  const inStock = !!(inventory && inventory.quantityStocked);
  const deliveryTimeEst = inventory && inventory.deliveryTimeEst;
  const leadTimeEst = inventory && inventory.leadTimeEst;
  const timeEstimate = inStock ? deliveryTimeEst : leadTimeEst;
  //
  let indicatorCollor: IndicatorCollor = 'bg-primary-green';

  if (inStock && deliveryTimeEst) {
    indicatorCollor = 'bg-primary-green';
  } else if (!inStock && leadTimeEst) {
    if (leadTimeEst === deliveryTimeEst) {
      indicatorCollor = 'bg-primary-green';
    } else {
      indicatorCollor = 'bg-primary-yellow';
    }
  }

  return (
    <>
      <div
        className={clsx(
          indicatorCollor,
          'rounded-full w-2-0 h-2-0 md:w-1-0 md:h-1-0  mr-2-0 md:mr-1-0',
        )}
        role="stock-indicator"
      ></div>
      <p className="text-2-0 md:text-1-2" role="estimate-value">
        {timeEstimate
          ? t('inventory.delivery_with_value', { value: timeEstimate })
          : inStock
          ? t('inventory.in_stock')
          : t('inventory.available')}
      </p>
    </>
  );
};

export default DeliveryEstimate;
